import { render, staticRenderFns } from "./ChatTray.vue?vue&type=template&id=edbbf9fa&scoped=true&"
import script from "./ChatTray.vue?vue&type=script&lang=js&"
export * from "./ChatTray.vue?vue&type=script&lang=js&"
import style0 from "./ChatTray.vue?vue&type=style&index=0&id=edbbf9fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbbf9fa",
  null
  
)

export default component.exports